// Saving operations, customers and boats: to the database first, then this device's copy
// (updateJobInfo / updateCustomerInfo / updateBoatInfo, addJobFirebase, updateJobStatus, the
// tech job lists), and the lookups that go with them (getCustomerRecord, getJobDataDB, getTechId).
// Moved out of app.js unchanged (docs/split-plan.md, session 7c).
import { database } from './initFirebase';
import { getTodaysDate } from './laborParts';
import { update } from './trackedDb';
import { fetchIdToken, getDB, updateTimestamps } from './utilities';
import { onValue, ref } from 'firebase/database';

let shell = null;
export function setJobWritesDeps(deps) { shell = deps; }

export async function getCustomerRecord(customerId) {
  return new Promise(async (resolve, reject) => {
    try {
      const db = await getDB();
      const transaction = db.transaction("customerData", "readonly");
      const objectStore = transaction.objectStore("customerData");

      if (!customerId) {
        resolve(null);
        return;
      }

      const request = objectStore.get(customerId);

      request.onsuccess = function () {
        resolve(request.result || null);
      };

      request.onerror = function () {
        reject("Could not retrieve customer data: " + request.error);
      };
    } catch (error) {
      reject("IndexedDB error: " + (error?.message || error));
    }
  });
}


export async function updateJobDB(jobId, index, value) {
  const today = await getTodaysDate();

  try {
    const db = await getDB();
    const transaction = db.transaction("jobData", "readwrite");
    const objectStore = transaction.objectStore("jobData");

    const itemToUpdate = await new Promise((resolve, reject) => {
      const req = objectStore.get(jobId);
      req.onerror = () => {
        console.error("Error fetching data");
        reject(req.error);
      };
      req.onsuccess = () => resolve(req.result || null);
    });

    if (!itemToUpdate) {
      console.error(`No item found with Job_ID ${jobId}`);
      return;
    }

    itemToUpdate[index] = value;

    if (value === 'Ready to Bill') {
      itemToUpdate['Complete_Date'] = today;
    }

    await new Promise((resolve, reject) => {
      const req = objectStore.put(itemToUpdate);
      req.onerror = () => {
        console.error("Error updating data");
        reject(req.error);
      };
      req.onsuccess = () => resolve();
    });
  } catch (error) {
    console.log("Error updating IndexedDB", error);
  }
}


async function updateCustomerDB(customerId, index, value) {
  try {
    const db = await getDB();
    const transaction = db.transaction("customerData", "readwrite");
    const objectStore = transaction.objectStore("customerData");

    const itemToUpdate = await new Promise((resolve, reject) => {
      const req = objectStore.get(customerId);
      req.onerror = () => {
        console.error("Error fetching data");
        reject(req.error);
      };
      req.onsuccess = () => resolve(req.result || null);
    });

    if (!itemToUpdate) {
      console.error(`No item found with Job_ID ${customerId}`);
      return;
    }

    itemToUpdate[index] = value;

    await new Promise((resolve, reject) => {
      const req = objectStore.put(itemToUpdate);

      req.onsuccess = function () {
        console.log(`Data updated for Job_ID ${customerId}`);
        resolve();
      };

      req.onerror = function () {
        console.error("Error updating data");
        reject(req.error);
      };
    });
  } catch (error) {
    console.log("Error updating IndexedDB", error);
  }
}


async function updateBoatDB(customerId, boatId, index, value) {
  try {
    const db = await getDB();
    const transaction = db.transaction("customerData", "readwrite");
    const objectStore = transaction.objectStore("customerData");

    const customerData = await new Promise((resolve, reject) => {
      const req = objectStore.get(customerId);
      req.onerror = () => {
        console.error("Error fetching customer data");
        reject(req.error);
      };
      req.onsuccess = () => resolve(req.result || null);
    });

    if (!customerData) {
      console.error(`No customer found with Customer_ID ${customerId}`);
      return;
    }

    if (!customerData.Boats || !customerData.Boats[boatId]) {
      console.error(`No boat found with Boat_ID ${boatId}`);
      return;
    }

    customerData.Boats[boatId][index] = value;

    await new Promise((resolve, reject) => {
      const req = objectStore.put(customerData);

      req.onsuccess = function () {
        console.log(`Data updated for Boat_ID ${boatId} under Customer_ID ${customerId}`);
        resolve();
      };

      req.onerror = function () {
        console.error("Error updating data");
        reject(req.error);
      };
    });
  } catch (error) {
    console.log("Error updating IndexedDB", error);
  }
}


export async function getJobDataDB(jobId) {
  const db = await getDB();
  const tx = db.transaction("jobData", "readonly");
  const store = tx.objectStore("jobData");
  return await new Promise((res, rej) => {
    const req = store.get(jobId);
    req.onerror = () => rej(req.error);
    req.onsuccess = () => res(req.result || null);
  });
}


export async function getJobsByWorkOrder(workOrder) {
  return new Promise(async (resolve, reject) => {
    try {
      const db = await getDB();
      const transaction = db.transaction("jobData", "readonly");
      const objectStore = transaction.objectStore("jobData");

      const jobs = [];
      const cursorRequest = objectStore.openCursor();

      cursorRequest.onsuccess = function (event) {
        const cursor = event.target.result;
        if (cursor) {
          const jobData = cursor.value;
          if (jobData.Work_Order === workOrder) {
            jobs.push(jobData);
          }
          cursor.continue();
        } else {
          resolve(jobs);
        }
      };

      cursorRequest.onerror = function () {
        console.error("Error fetching data");
        reject(new Error("Error fetching data"));
      };

    } catch (error) {
      console.log("Error retrieving data from IndexedDB", error);
      reject(error);
    }
  });
}


export function getTechId(name) {
  let techs = {
    "Theo": "56",
    "Damon": "43",
    "Nico": "58",
    "Cassius": "70",
    "Silas": "57",
    "Tobias": "55",
    "Grant": "36",
    "Nolan": "33"
  }
  return techs[name]
}

async function addJobToTech(row, tech) {

  console.log(row)
  console.log(tech)

  let jobId = row.Job_ID;

  try {

    // Update the Techs value in /data/jobID
    const dataJobRef = ref(database, `data/${jobId}`);
    await update(dataJobRef, {
      Techs: tech,
    });
    await updateJobDB(jobId, "Techs", tech);
    console.log("Techs value updated successfully");
  } catch (e) {
    console.error("Error adding job to tech: " + e.toString());
  }
}

export async function addJobFirebase(serviceLog) {

  let start
  if (serviceLog.Category === "Spring Commissioning" &&
      serviceLog.Description.toLowerCase().includes('bottom paint') &&
      serviceLog.Launch_Date !== "") {
    start = serviceLog.Launch_Date
  } else if (serviceLog.Category === "Spring Commissioning" &&
    serviceLog.Launch_Date !== "") {
    start = serviceLog.Launch_Date
  } else if (serviceLog.Category === 'Winterizing' &&
    serviceLog.Haul_Date !== "") {
    start = serviceLog.Haul_Date
  } else { start = serviceLog.Request_Date }

  let data = {
    'Billing User': "",
    'Boat_ID': serviceLog.Boat_ID,
    'Boat_Name': serviceLog.Boat_Name,
    'Category': serviceLog.Category,
    'Charge': "",
    'Customer_ID': serviceLog.Customer_ID,
    'Customer_Name': serviceLog.Customer_Name,
    'Date Billed': "",
    'Date_Hauled': "",
    'Date_Launched': "",
    'Description': serviceLog.Description,
    'Email': serviceLog.Email,
    'Estimated_Hours': serviceLog.Estimated_Hours,
    'Event_Added': "",
    'Event_Time': "",
    'Haul_Date': serviceLog.Haul_Date,
    'Hold_Days': "",
    'Job_ID': serviceLog.Job_ID,
    'Labor Billed': "",
    'Launch_Date': serviceLog.Launch_Date,
    'Location_Number': "",
    'Notes': serviceLog.Notes,
    'OpCode': serviceLog.OpCode,
    'Op_Type': serviceLog.Op_Type,
    'Operation_Dependency': serviceLog.Operation_Dependency,
    'Parts Billed': "",
    'Parts Ordered': "",
    'Parts_Kit_Status': "",
    'Priority': "",
    'Ready': "",
    'Request_Date': serviceLog.Request_Date,
    'Schedule_Date': serviceLog.Schedule_Date,
    'Short_Description': serviceLog.Short_Description,
    'Short_Description_DM': serviceLog.Short_Description_DM,
    'Start_Date': start,
    'Status': serviceLog.Status,
    'Status_Of_Boat': "",
    'Techs': serviceLog.Techs,
    'Transfer_to_Billing': "",
    'Water': "",
    'Work_Order': serviceLog.Work_Order,
    'Work_Order_ID': "",
    'Yard': ""
  };


  let jobId = data.Job_ID;
  const idToken = await fetchIdToken();
  const firebaseUrl = shell.currentURL;
  const path = `/data/${jobId}.json?auth=${idToken}`;
  const timestampPath = `/data/lastUpdated.json?auth=${idToken}`;

  try {
    const response = await fetch(firebaseUrl + path, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    });
    const result = await response.json();
    console.log("Job added successfully", result);
  } catch (e) {
    console.error("Error adding job to tech: " + e.toString());
  }

  try {
    const timestampResponse = await fetch(firebaseUrl + timestampPath, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ".sv": "timestamp" })
    });
    const timestampResult = await timestampResponse.json();
    console.log("Timestamp updated successfully", timestampResult);
  } catch (e) {
    console.error("Error updating timestamp: " + e.toString());
  }

}


export async function updateJobStatus(jobID, status) {

  try {
    const idToken = await fetchIdToken(); // Assume this fetches the ID token
    const firebaseUrl = `${shell.currentURL}/data/${jobID}.json?auth=${idToken}`;

    const today = await getTodaysDate();

    let partialUpdate = {};

    if (status === 'Ready to Bill' || status === 'Complete') {
      partialUpdate = { "Status": status, "Operation_Dependency": 0, "Complete_Date": today };
    }else{
      partialUpdate = { "Status": status, "Operation_Dependency": 0};
    }

    const options = {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(partialUpdate),
    };

    const response = await fetch(firebaseUrl, options);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const result = await response.json();
    
    await updateJobDB(jobID, 'Status', status);
    await updateJobDB(jobID, 'Operation_Dependency', 0);

    if (status === 'Ready to Bill' || status === 'Complete') {
      await updateJobDB(jobID, 'Complete_Date', today);
    }

    updateTimestamps('jobData', 'data');

  } catch (error) {
    console.error("Error modifying job status:", error);
  }
}

// strict: rethrow on failure so the caller can show it (the op panel's "Saved"
// indicator and status pills); everything else keeps the log-and-continue default.
export async function updateJobInfo(jobID, index, value, { strict = false } = {}) {
  if (!jobID) { // a blank id would write into /data itself
    if (strict) throw new Error('updateJobInfo: no operation id');
    return;
  }

  try {
    const idToken = await fetchIdToken();
    const firebaseUrl = `${shell.currentURL}/data/${jobID}.json?auth=${idToken}`;

    let requestBody = { [index]: value };

    if (index === 'Status' && value === 'On Work Schedule') {
      const opCode = await shell.opCodeCheck(jobID);

      if (opCode.Dependency === 1) {
        requestBody = Object.assign(requestBody, { Operation_Dependency: 1 });
      }
    }

    const options = {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    };

    const response = await fetch(firebaseUrl, options);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const result = await response.json();
    updateTimestamps('jobData', 'data');

  } catch (error) {
    console.error("Error updating job info:", error);
    if (strict) throw error;
  }
}


export async function updateCustomerInfo(customerId, index, value) {
  if (!customerId) return; // a blank id would write to /customers itself
  try {
    // Update Firebase Realtime Database
    const idToken = await fetchIdToken();
    const firebaseUrl = `${shell.currentURL}/customers/${customerId}.json?auth=${idToken}`;

    const partialUpdate = { [index]: value };

    const options = {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(partialUpdate),
    };

    const response = await fetch(firebaseUrl, options);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const result = await response.json();
    console.log("Firebase update successful", result);

    // Update IndexedDB
    await updateCustomerDB(customerId, index, value);
    updateTimestamps('customerData', 'customers');
    console.log("IndexedDB update successful");

  } catch (error) {
    console.error("Error updating job info:", error);
  }
}

export async function updateBoatInfo(customerId, boatId, index, value) {
  if (!customerId || !boatId) return; // blank ids collapse to a stray /customers/Boats record
  try {
    // Update Firebase Realtime Database
    const idToken = await fetchIdToken();
    const firebaseUrl = `${shell.currentURL}/customers/${customerId}/Boats/${boatId}.json?auth=${idToken}`;

    const partialUpdate = { [index]: value };

    const options = {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(partialUpdate),
    };

    const response = await fetch(firebaseUrl, options);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const result = await response.json();
    console.log("Firebase update successful", result);

    // Update IndexedDB
    await updateBoatDB(customerId, boatId, index, value);
    updateTimestamps('customerData', 'customers');
    console.log("IndexedDB update successful");

  } catch (error) {
    console.error("Error updating job info:", error);
  }
}

async function removeJobFromTech(jobId, tech, changed) {
  const techId = getTechId(tech);
  const firebaseUrl = shell.currentURL;
  const schedulePath = `/scheduleDatabase/${techId}/jobs/${jobId}.json`;
  const dataPath = `/data/${jobId}.json`;

  try {
    // Remove the job from the old technician's schedule
    await fetch(firebaseUrl + schedulePath, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      }
    });
    console.log("Job removed successfully from old tech");

    // Update the job's Techs field in the /data node
    const updateResponse = await fetch(firebaseUrl + dataPath, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ Techs: "" }) // Set Techs to an empty string
    });

    if (updateResponse.ok) {
      console.log(`Techs cleared for job ${jobId}`);
    } else {
      console.error(`Failed to clear Techs for job ${jobId}`);
    }
  } catch (e) {
    console.error("Error removing job from old tech or clearing Techs: " + e.toString());
  }
  if (!changed) {
    await updateJobDB(jobId, 'Techs', '');
  }
}

let isUpdating = false;

function listenForUpdates() {

  if (!navigator.onLine) {
    console.log('User is offline. Skipping function.');
    return;
  }

  const scheduleRef = ref(database, '/scheduleDatabase');
  onValue(scheduleRef, async (snapshot) => {
    if (!isUpdating) {
      isUpdating = true; // Indicate an update is in progress
      document.getElementById('workList').innerHTML = ''; // Clear the content
      isUpdating = false; // Reset the flag once update is complete


    }
  });
}

listenForUpdates();
